import { render } from "./ObjectPathString.vue?vue&type=template&id=522b5c7a"
import script from "./ObjectPathString.vue?vue&type=script&lang=js"
export * from "./ObjectPathString.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/OpenMCT/OpenMCT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__